export const Bio = {
  name: "Michelle Fiona Opiyo",
  roles: [
    "React.js Developer",
    "Next.js Developer",
    "Wordpress Developer",
    "Frontend Developer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. My positive attitude and a growth mindset, also means I am ready to make a meaningful contribution and achieve great things.Recently developed a keen interest in exploring HTML5 games, and I'm excited to dive deeper into their creative and interactive possibilities.",
  github: "https://github.com/fiona02",
  resume:"https://drive.google.com/file/d/1WAT0m3Hm9q4GhD5SsrXoJXCO7vARK4V_/view?usp=drive_link",
  twitter: "https://twitter.com/Op11Fiona29Mi02",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/reactjs-svgrepo-com.png",
      },
      {
        name: "Redux",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/redux-svgrepo-com.png",
      },
      {
        name: "Next Js",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/next-js-svgrepo-com.png",
      },
      {
        name: "HTML",
        image: "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/html-5-svgrepo-com.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/tailwindcss-icon-svgrepo-com.png",
      },
      {
        name: "JavaScript",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/javascript-svgrepo-com.png",
      },
      {
        name: "TypeScript",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/typescript-logo-svgrepo-com.png",
      },
      {
        name: "Material UI",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/material-ui-svgrepo-com.png",
      },
      {
        name: "Bootstrap",
        image:"https://raw.githubusercontent.com/fiona02/images/refs/heads/main/bootstrap-svgrepo-com.png",
      },
       {
        name: "WordPress",
        image:"https://raw.githubusercontent.com/fiona02/images/refs/heads/main/wordpress-svgrepo-com.png",
      },
       {
        name: "WooComerce",
        image:"https://raw.githubusercontent.com/fiona02/images/refs/heads/main/woo-commerce-svgrepo-com.png",
      },
       {
        name: "Elementor",
        image:"https://raw.githubusercontent.com/fiona02/images/refs/heads/main/elementor.jfif",
      },
       {
        name: "SquareSpace",
        image:"https://raw.githubusercontent.com/fiona02/images/refs/heads/main/squarespace-svgrepo-com.png",
      },
       {
        name: "Webflow",
        image:"https://raw.githubusercontent.com/fiona02/images/refs/heads/main/webflow-svgrepo-com.png",
      }

    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/nodejs-1-logo-svgrepo-com.png",
      },
      {
        name: "Express Js",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/node-svgrepo-com.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/mongodb-logo-svgrepo-com.png",
      },
      {
        name: "PostgreSQL",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/postgreSQL.jfif",
      },
            ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/git-svgrepo-com.png",
      },
      {
        name: "GitHub",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/github-color-svgrepo-com.png",
      },
      {
        name: "Firebase",
        image: "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/firebase-svgrepo-com.png",
      },
      {
        name: "VS Code",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/vs-code-svgrepo-com.png",
      },
      {
        name: "Postman",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/postman-icon-svgrepo-com.png",
      },
      {
        name: "Figma",
        image:
          "https://raw.githubusercontent.com/fiona02/images/refs/heads/main/figma-svgrepo-com.png",
      },
    ],
  },
];

export const projects = [
  {
    id: 1,
    title: "Fashion ecommerce store",
    date: "April 2021 - July 2021",
    description:
      "Presenting a contemporary and chic e-commerce platform where users can effortlessly navigate a range of features. The website seamlessly incorporates shopping cart functionality for easy add, remove, and update actions, allowing users to view product details, leave reviews/comments, and efficiently search and filter products. With a fully responsive design, the platform ensures a smooth experience across devices. The checkout process, powered by Paypal sandbox, enables secure order placement and payment transactions. The implementation of JWT authentication enhances user security,the platform supports image uploads via Cloudinary, contributing to a visually engaging shopping experience. Built with React, Redux, Material-UI on the client side, and Node, Express, MongoDB, mongoose on the server side, this app combines style with functionality to deliver a user-friendly e-commerce solution.",
    image:
      "https://raw.githubusercontent.com/fiona02/images/main/fashion.jpg",
    tags: ["React Js", "Redux", "Material-UI", "SCSS", "Node Js", "Express Js", "Mongo DB","JWT","Cloudinary","Paypal sandbox"],
    category: "fullstack",
    github: "https://github.com/fiona02/ecommerce_shop",
    webapp: "https://fashion-shopp.vercel.app/",
  },
  {
    id: 1,
    title: "A HTML5 Game",
    date: "April 2021 - July 2021",
    description:
      "The project is an HTML5 platformer game inspired by Super Mario game, developed using the Kaboom.js library. Players navigate through multiple levels, collecting coins to progress while avoiding enemies like spiders and birds and environmental hazards such as swinging axes and moving platforms. The game includes features like one-way collisions, sound effects, and vibrant visuals, with assets and sounds.",
    image:
      "https://raw.githubusercontent.com/fiona02/html5_game/refs/heads/main/kaboom.png",
    tags: ["HTMl5", "Javascript", "Kaboom.js"],
    category: "frontend",
    github: "https://github.com/fiona02/html5_game",
    webapp: "https://fiona02.github.io/html5_game/",
  },
  {
    id: 1,
    title: "Microsoft Loop 2.0",
    date: "April 2021 - July 2021",
    description:
      "This project is a Next.js full stack application integrated with Microsoft Loop 2.0, designed to deliver a robust and feature-rich experience. It combines React for dynamic user interfaces, TailwindCSS for customizable styling, and Gemini API for advanced functionality. Authentication is managed effortlessly with Clerk, while Liveblock powers real-time collaboration. The backend is built on Firebase, ensuring reliability and scalability, making it a comprehensive solution for modern web applications.",
    image:
      "https://raw.githubusercontent.com/fiona02/microsoft_loop_2.0/refs/heads/main/Screenshot%202024-12-27%20190858.png",
    tags: ["Next.js", "Javascript", "Clerk Authentication", "Tailwind CSS", "Gemini API","Liveblocks","Firebase"],
    category: "fullstack",
    github: "https://github.com/fiona02/microsoft_loop_2.0",
    webapp: "https://microsoft-loop-five.vercel.app/",
  },

  {
    id: 4,
    title: "YourBank",
    date: "January 2024",
    description:
      "A modern, responsive website for YourBank, leveraging the latest web technologies to ensure a seamless user experience. The site showcases a sleek design with smooth animations and intuitive navigation, providing users with quick access to essential banking services.",
    image:
      "https://raw.githubusercontent.com/fiona02/your_bank_frontend/main/Screenshot%202024-07-28%20113030.png",
    tags: ["Next Js","TypeScript","Tailwind CSS", "Framer Motion" ,"date-fns", "react-hook-form","Sonner"],
    category: "frontend",
    github: "https://github.com/fiona02/your_bank_frontend",
    webapp: "https://yourbank-demo.vercel.app/",
  },
  {
    id: 7,
    title: "CarePulse",
    date: "February 2023- March 2023",
    description:
      "CarePulse is a modern web application designed to streamline patient registration, appointment scheduling, and medical records management. This platform enhances healthcare efficiency and user experience through advanced technologies and software development best practices. It bridges the gap between patients and healthcare providers, offering an intuitive interface for managing appointments, accessing medical records, and ensuring timely communication via SMS notifications.",
    image:
      "https://raw.githubusercontent.com/fiona02/carepulse/main/Screenshot%202024-07-29%20160600.png",
    tags: ["Next Js", "Appwrite", "Typescript", "Tailwind CSS","Twilio"],
    category: "fullstack",
    github: "https://github.com/fiona02/carepulse",
    webapp: "https://healthcare-carepulse.vercel.app/",
  },
  {
    id: 7,
    title: "InterviewX",
    date: "February 2023- March 2023",
    description:
      "InterviewX is an advanced web application designed to revolutionize interview preparation. Built with Next.js, it provides users with a personalized mock interview experience by generating AI-powered questions based on their chosen job role, tech stack, and experience level. Featuring real-time feedback, performance tracking, and detailed analysis, InterviewX helps users sharpen their skills with actionable insights. Powered by Gemini AI and a robust tech stack including PostgreSQL and TailwindCSS, InterviewX delivers a seamless, user-friendly interface for comprehensive interview practice.",
    image:
      "https://raw.githubusercontent.com/fiona02/ai-mock-interview/refs/heads/main/Screenshot%202024-12-27%20185017.png",
    tags: ["Next Js", "Gemini API", "Tailwind CSS","PostgreSQL","Neon DB","Drizzle ORM", "ShadcnUI"],
    category: "fullstack",
    github: "https://github.com/fiona02/ai-mock-interview",
    webapp: "https://interviewx-chi.vercel.app/",
  },
  {
    id: 7,
    title: "Erasor.io Clone",
    date: "February 2023- March 2023",
    description:
      "This project is a fully functional clone of Eraser.io, developed using modern web technologies such as Next.js, React, TypeScript, and Tailwind CSS. It features secure user authentication powered by Kinde, a versatile whiteboard canvas for collaborative drawing, and seamless integration of document editing and whiteboard functionality within the same interface. Users can manage teams, create and retrieve files, and choose between free and paid plans. With over 50 document features and 30 whiteboard tools, it offers extensive capabilities for productivity and collaboration. The application leverages Convex Database for scalable and robust data management.",
    image:
      "https://raw.githubusercontent.com/fiona02/erasor-io-clone/refs/heads/main/Screenshot%202024-12-27%20194416.png",
    tags: ["Next Js", "TypeScript", "Kinde Authentication","Tailwind","ShadcnUI"],
    category: "fullstack",
    github: "https://github.com/fiona02/erasor-io-clone",
    webapp: "https://erasor-clone.vercel.app/",
  },
  {
    id: 9,
    title: "Brainwave",
    date: "April 2021 - July 2021",
    description:
    "Brainwave is a cutting-edge UI/UX website crafted with React.js and Tailwind CSS, showcasing sleek design, seamless animations, and an exceptional user experience. Featuring parallax animations, intricate UI geometry, and the latest design trends like bento grids and stylish gradients, it sets a new standard for modern applications.",
    image:
      "https://raw.githubusercontent.com/fiona02/images/main/web1.png",
    tags: ["React Js", "Tailwind CSS"],
    category: "frontend",
    github: "https://github.com/fiona02/brainwave",
    webapp: "https://brainwaveai-fiona02s-projects.vercel.app/",
  },
  {
    id: 7,
    title: "Iphone 15 landing page",
    date: "February 2023- March 2023",
    description:
      "This project is a meticulously crafted clone of Apple's iPhone 15 Pro website, developed using React.js and TailwindCSS. It showcases the advanced use of GSAP for smooth animations and Three.js for interactive 3D rendering of iPhone 15 Pro models in various colors and sizes.",
    image:
      "https://raw.githubusercontent.com/fiona02/iphone15pro/main/Screenshot%202024-08-25%20163252.png",
    tags: ["React Js", "Three js", "React Three Fiber", "React Three Drei","GSAP (greenstock", "Tailwind CSS"],
    category: "frontend",
    github: "https://github.com/fiona02/iphone15pro",
    webapp: "https://iphone-doc.vercel.app/",
  },
  {
    id: 9,
    title: "Home Axil",
    date: "April 2021 - July 2021",
    description:
    "A sleek, multipage website designed for an interior company, showcasing modern design and seamless user experience. Developed using cutting-edge technologies to ensure smooth animations, responsive layouts, and efficient performance.",
    image:
      "https://raw.githubusercontent.com/fiona02/interior_multipage/main/Screenshot%202024-08-25%20162655.png",
    tags: ["Next Js 14", "Tailwind CSS", "Framer Motion"],
    category: "frontend",
    github: "https://github.com/fiona02/interior_multipage",
    webapp: "https://homeaxil-interior.vercel.app/",
  },
  {
    id: 8,
    title: "GenZ Chat App",
    date: "August 2021 - December 2021",
    description:
      "GenZ, the vibrant chat app, boasts a dynamic blend of features enhancing user interaction. Emojis infuse conversations with emotion, while seamless file, video, and image uploads add depth to exchanges. The app’s adaptive interface caters to preferences, offering both dark and light modes. Functionality flourishes with room creation and member invitations, fostering inclusive discussions. Under the hood, React powers the interface's responsiveness, Redux manages state efficiently, and Firebase plays a pivotal role, handling authentication, storing chat data via Firestore, and securely housing multimedia via Cloud Storage.",
    image:
      "https://raw.githubusercontent.com/fiona02/images/main/genzchatapp.jpg",
    tags: ["React Js", "Redux","Firebase authentication", "Firestore","SCSS"],
    category: "fullstack",
    github: "https://github.com/fiona02/chat_app2",
    webapp: "https://genz-chat.web.app/",
  },
   {
    id: 3,
    title: "Moonflix",
    date: "April 2023 - May 2023",
    description:
      "Moonflix  which is more of a Netflix clone brings an immersive movie and TV series experience to users with a straightforward and user-friendly interface. Users can easily sign up or log in to their accounts, enabling them to save their favorite movies or remove them from their list effortlessly. They can also share their thoughts by writing reviews and deleting them as needed. The search functionality allows users to explore a vast library of movies, TV series, and people. Additionally, the app offers both light and dark themes for personalized viewing. Behind the scenes, Moonflix harnesses technologies like React, Material UI, and React Router v6 on the frontend, ensuring a smooth and engaging user interface. It leverages Formik and Yup for robust form handling, SwiperJS for seamless navigation, and Axios for efficient data fetching. On the backend, the app utilizes Express REST API, Express Validator, Jsonwebtoken, and Mongoose, along with Axios for reliable data management, authentication, and database interaction, providing a secure and efficient foundation for its functionalities.",
    image:
      "https://raw.githubusercontent.com/fiona02/images/main/moonflix.jpg",
    tags: ["React Js", "React Router v6", "Material UI", "Swiper Js","MongoDB","Node Js", "Express Js","JWT","Formik","Yup"],
    category: "fullstack",
    github: "https://github.com/fiona02/moviewebsite",
    webapp: "https://moonflix.vercel.app/",
  },
  {
    id: 6,
    title: "CryptoBucks",
    date: "August2022 - October 2022",
    description:
      "Cryptobucks is a React-powered website known for its feature-packed Crypto Screener App. It's designed using Tailwind CSS for a sleek look and Recharts for visualizing crypto data. This site fetches real-time crypto information using the CoinGeko API, allowing users to explore and track cryptocurrencies effortlessly.",
    image:
      "https://raw.githubusercontent.com/fiona02/images/main/cryptobucks.jpg",
    tags: ["React Js", "CoinGeko API", "Recharts", "Tailwind CSS"],
    category: "frontend",
    github: "https://github.com/fiona02/crypto_website",
    webapp: "https://crypto-bucks.netlify.app/",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
